


















import _ from 'lodash'
import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

@Component
export default class Modal extends Vue {

    /**
     * Icono para la barra de herramientas
     */
    @Prop({default: false, type: [String, Boolean]})
    public toolbarIcon: false | string

    /**
     * Texto para el botón de aceptar
     */
    @Prop({default: 'Aceptar', type: String})
    public acceptButtonText: string

    /**
     * Texto para el botón de cancelar
     */
    @Prop({default: 'Cancelar', type: String})
    public cancelButtonText: string

    /**
     * Título del modal
     */
    @Prop({default: 'Dialogo modal', type: String})
    public title: string

    /**
     * Mutación invocada cuando el usuario pulsa en botón cancelar
     */
    @Prop({required: true})
    public cancelMutation: string


    /**
     * Nombre de la propiedad en el estado de Vuex que indica la visibilidad
     * del modal
     */
    @Prop({required: true, type: String})
    public vuexState: string

    /**
     * Visibilidad del modal
     */
    get visibility (): boolean {
        if (!_.has(this.$store.state, this.vuexState)) {
            throw new Error(`La propiedad ${this.vuexState} no existe en el estado de Vuex`)
        }

        const value = _.get(this.$store, this.vuexState)
        if (!_.isBoolean(value)) {
            throw new Error(`La propiedad ${this.vuexState} debe ser un booleano`)
        }

        return value
    }

    /**
     * Cancela el modal
     */
    public cancel () {
        this.$store.commit(this.cancelMutation)
    }
}
